import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import { ParallaxProvider } from 'react-scroll-parallax';
import Filter from '../../src/components/Filter';
import Watermark from '../../src/components/Parallax/Watermark';
import theme from '../../src/theme';
import Category from './Category/';

class EventList extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      ...this.hydrateState(props.events)
    };
  }

  hydrateState = events => {
    let state = {};
    const { category } = this.props;
    events.forEach(eventCategory => {
      if (category) {
        state[eventCategory.id] = eventCategory.slug === category;
      } else {
        state[eventCategory.id] = true;
      }
    });

    return state;
  };

  toggleCategory = id => {
    this.setState(prevState => ({
      [id]: !prevState[id]
    }));
  };

  renderCategory = (category, index) => {
    const { label, id, items, slug } = category;
    return (
      this.state[id] && (
        <Category
          key={index}
          label={label}
          name={id}
          items={items}
          categorySlug={slug}
          backgroundColor={
            index % 2 === 1
              ? theme.color.brand.lightGrey
              : theme.color.brand.white
          }
        />
      )
    );
  };

  renderCategories = () => {
    return this.props.events.map(this.renderCategory);
  };

  render() {
    const { t } = this.props;
    return (
      <div>
        <Filter
          title={t('common:brands.filters.title')}
          data={this.props.events}
          filters={this.state}
          toggleCategory={this.toggleCategory}
        />
        {this.renderCategories()}
      </div>
    );
  }
}

EventList.propTypes = {
  events: PropTypes.array
};

export default EventList;
